/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/common';
import * as import2 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import3 from 'angular2-spinner/dist/angular2-spinner';
import * as import4 from '@ngx-translate/core/src/translate.pipe';
import * as import5 from '@ngx-translate/core/src/translate.service';
import * as import6 from '@angular/forms';
import * as import7 from '../../../app/shared/directives/no-blank.directive';
import * as import8 from 'ngx-pagination';
import * as import9 from '../../../$$_gendir/node_modules/ngx-pagination/dist/ngx-pagination.ngfactory';
import * as import10 from './server-transfer.component.ngfactory';
import * as import11 from '../../../app/server/server-transfer.component';
import * as import12 from '../../../app/services/api.service';
import * as import13 from '../../../app/services/response.service';
import * as import14 from '../../../app/shared/directives/clipboard.directive';
import * as import15 from 'angular2-notifications/src/notifications.service';
import * as import16 from '../../../$$_gendir/node_modules/ngx-modal/Modal.ngfactory';
import * as import17 from 'ngx-modal/Modal';
import * as import18 from '../../../app/pipes/filter-by-keys.pipe';
import * as import19 from '../../../app/server/server-dashboard.component';
import * as import20 from '../../../app/services/local-storage.service';
import * as import21 from '../../../app/services/ipmi.service';
import * as import22 from '@angular/router';
import * as import23 from '../../../app/services/form.service';
import * as import24 from '../../../app/services/menu.service';
const styles_ServerDashboardComponent:any[] = ([] as any[]);
export const RenderType_ServerDashboardComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ServerDashboardComponent,
  data: {}
}
);
function View_ServerDashboardComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.restartServer(import0.ɵnov((<any>v.parent),81))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zrestartuj serwer']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkingStatus;
    ck(v,0,0,currVal_0);
  });
}
function View_ServerDashboardComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    To pole jest wymagane\n                                ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    Niepoprawny adres IP\n                                ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'info-hint error'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_3)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_4)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.IPMIAccessForm.controls['allowed_ip'].touched && ((co.IPMIAccessForm.controls['allowed_ip'].errors == null)? (null as any): co.IPMIAccessForm.controls['allowed_ip'].errors.required));
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.IPMIAccessForm.controls['allowed_ip'].touched && ((co.IPMIAccessForm.controls['allowed_ip'].errors == null)? (null as any): co.IPMIAccessForm.controls['allowed_ip'].errors.IP));
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_ServerDashboardComponent_5(l:any):import0.ɵViewDefinition {
    return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'type',
        'submit'
      ]
      ,
      [
        'value',
        'Uzyskaj dostęp'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:boolean = !co.IPMIAccessForm.valid;
    ck(v,0,0,currVal_0);
  });
}
function View_ServerDashboardComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.stopNAT()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wyłącz\n                        dostęp']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.accessForAll()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Ustaw dostęp dla wszystkich']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'type',
        'button'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.accessForCurrentIP()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Ustaw dostęp tylko dla tego adresu']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Adres IP:'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.IPMIData.nat_ip;
    ck(v,7,0,currVal_0);
  });
}
function View_ServerDashboardComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Adres FQDN:'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'https://',co.IPMIData.nat_fqdn,'');
    ck(v,7,0,currVal_0);
    const currVal_1:any = co.IPMIData.nat_fqdn;
    ck(v,8,0,currVal_1);
  });
}
function View_ServerDashboardComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Login:'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.IPMIData.operator_name;
    ck(v,7,0,currVal_0);
  });
}
function View_ServerDashboardComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Hasło:'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.IPMIData.operator_pass;
    ck(v,7,0,currVal_0);
  });
}
function View_ServerDashboardComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'form',[
      [
        'method',
        'post'
      ]
      ,
      [
        'ngNoForm',
        ''
      ]
      ,
      [
        'target',
        '_blank'
      ]

    ]
      ,[[
        8,
        'action',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'name',
        'name'
      ]
      ,
      [
        'type',
        'hidden'
      ]

    ]
      ,[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'name',
        'pwd'
      ]
      ,
      [
        'type',
        'hidden'
      ]

    ]
      ,[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'type',
        'submit'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zaloguj się do karty zarządzającej'])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'https://',co.IPMIData.nat_fqdn,'/cgi/login.cgi');
    ck(v,0,0,currVal_0);
    const currVal_1:any = import0.ɵinlineInterpolate(1,'',co.IPMIData.operator_name,'');
    ck(v,2,0,currVal_1);
    const currVal_2:any = import0.ɵinlineInterpolate(1,'',co.IPMIData.operator_pass,'');
    ck(v,4,0,currVal_2);
  });
}
function View_ServerDashboardComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie danych serwera'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import2.View_SpinnerComponent_0,import2.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import3.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_ServerDashboardComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                              ',
      '\n                          '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_ServerDashboardComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[
      [
        'class',
        'info-hint error'
      ]
      ,
      [
        'style',
        'margin-top:-6px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                          '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_18)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                      ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.changeServerDetailsForm.controls['name_external'].errors.required;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_ServerDashboardComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[
      [
        'class',
        'info-hint error'
      ]
      ,
      [
        'style',
        'margin-top:-6px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                          '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Tekst nie może przekraczać 1000 znaków.'])),
    (l()(),import0.ɵted((null as any),['\n                      ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),48,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),45,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,4).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,4).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('submit' === en)) {
        const pd_2:any = ((<any>co.changeServerName()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n              '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),34,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Nazwa serwera'])),
    (l()(),import0.ɵted((null as any),['\n                  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                      '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'medium-wide'
      ]
      ,
      [
        'formControlName',
        'name_external'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,16)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,16).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,16)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,16)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,21).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                      '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_17)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n                  '])),
    (l()(),import0.ɵted((null as any),['\n\n                  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwagi (opcjonalne)'])),
    (l()(),import0.ɵted((null as any),['\n                  '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                      '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'textarea',[
      [
        'class',
        'medium-wide'
      ]
      ,
      [
        'formControlName',
        'customer_comment'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,33)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,33).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,33)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,33)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                      '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_19)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                  '])),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'type',
        'submit'
      ]
      ,
      [
        'value',
        'Zapisz'
      ]

    ]
      ,[[
        8,
        'disabled',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n              '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'input',[
      [
        'class',
        'btn btn-small'
      ]
      ,
      [
        'type',
        'button'
      ]
      ,
      [
        'value',
        'Anuluj'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>(co.showChangeServerName = false)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_7:any = co.changeServerDetailsForm;
    ck(v,4,0,currVal_7);
    const currVal_15:any = 'name_external';
    ck(v,18,0,currVal_15);
    const currVal_16:any = co.changeServerDetailsForm.controls['name_external'].errors;
    ck(v,24,0,currVal_16);
    const currVal_24:any = 'customer_comment';
    ck(v,35,0,currVal_24);
    const currVal_25:any = co.changeServerDetailsForm.controls['customer_comment'].errors;
    ck(v,40,0,currVal_25);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵnov(v,6).ngClassUntouched;
    const currVal_1:any = import0.ɵnov(v,6).ngClassTouched;
    const currVal_2:any = import0.ɵnov(v,6).ngClassPristine;
    const currVal_3:any = import0.ɵnov(v,6).ngClassDirty;
    const currVal_4:any = import0.ɵnov(v,6).ngClassValid;
    const currVal_5:any = import0.ɵnov(v,6).ngClassInvalid;
    const currVal_6:any = import0.ɵnov(v,6).ngClassPending;
    ck(v,2,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
    const currVal_8:any = import0.ɵnov(v,20).ngClassUntouched;
    const currVal_9:any = import0.ɵnov(v,20).ngClassTouched;
    const currVal_10:any = import0.ɵnov(v,20).ngClassPristine;
    const currVal_11:any = import0.ɵnov(v,20).ngClassDirty;
    const currVal_12:any = import0.ɵnov(v,20).ngClassValid;
    const currVal_13:any = import0.ɵnov(v,20).ngClassInvalid;
    const currVal_14:any = import0.ɵnov(v,20).ngClassPending;
    ck(v,15,0,currVal_8,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14);
    const currVal_17:any = import0.ɵnov(v,37).ngClassUntouched;
    const currVal_18:any = import0.ɵnov(v,37).ngClassTouched;
    const currVal_19:any = import0.ɵnov(v,37).ngClassPristine;
    const currVal_20:any = import0.ɵnov(v,37).ngClassDirty;
    const currVal_21:any = import0.ɵnov(v,37).ngClassValid;
    const currVal_22:any = import0.ɵnov(v,37).ngClassInvalid;
    const currVal_23:any = import0.ɵnov(v,37).ngClassPending;
    ck(v,32,0,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23);
    const currVal_26:boolean = !co.changeServerDetailsForm.valid;
    ck(v,44,0,currVal_26);
  });
}
function View_ServerDashboardComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Serwer',
      ': ',
      ' ',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.server.is_colocated? ' kolokacyjny': '');
    const currVal_1:any = co.server.name_external;
    const currVal_2:any = (co.server.is_colocated? (('Wysokość: ' + co.server.height) + 'U'): '');
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  });
}
function View_ServerDashboardComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showChangeServerNameForm()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Edytuj szczegóły']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-medium btn-success btn-outline-success'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.goToBuyServices()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dokup usługi'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-medium'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.newMessage()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zgłoś awarię'])),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_23(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Status online: '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'target',
        '_blank'
      ]
      ],[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Sprawdź status'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',co.server.status_online,'');
    ck(v,6,0,currVal_0);
  });
}
function View_ServerDashboardComponent_25(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Adres główny: ',
      '/',
      '\n                    '
    ]
    )),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showIPS(v.context.$implicit,import0.ɵnov((<any>v.parent),51))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['(szczegóły)'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.prefix;
    const currVal_1:any = v.context.$implicit.prefix_len;
    ck(v,5,0,currVal_0,currVal_1);
  });
}
function View_ServerDashboardComponent_27(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/gears.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Twój serwer jest w trakcie konfigurowania'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_28(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'style',
        'padding-bottom:2px'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zasilanie'])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_30(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent),81).open()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Restart']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkingStatus;
    ck(v,0,0,currVal_0);
  });
}
function View_ServerDashboardComponent_29(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'td',[[
        'style',
        'padding:0px !important'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),56).open()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.refreshServerStatus(co.serviceID)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Odśwież stan'])),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_30)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = co.serverStatus;
    ck(v,11,0,currVal_3);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.checkingStatus;
    ck(v,4,0,currVal_0);
    const currVal_1:any = ((co.serverStatus == (null as any))? 'Czekaj...': (co.serverStatus? 'Wyłącz': 'Włącz'));
    ck(v,5,0,currVal_1);
    const currVal_2:any = co.checkingStatus;
    ck(v,7,0,currVal_2);
  });
}
function View_ServerDashboardComponent_31(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'style',
        'padding-bottom:2px'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Karta zarządzająca'])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_32(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'td',[[
        'style',
        'padding:0px !important'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-short-plus'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.openIPMI(co.serviceID,import0.ɵnov((<any>(<any>(<any>(<any>v.parent).parent).parent).parent),106))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uzyskaj\n                                            dostęp'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_33(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',[[
        'style',
        'padding-bottom:2px'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                        System operacyjny:\n                                        ',
      '\n                                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.serverOS.name !== '')? co.serverOS.name: 'Nie zainstalowano');
    ck(v,3,0,currVal_0);
  });
}
function View_ServerDashboardComponent_35(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'btn btn-short-plus'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showOSDataModal(import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),15))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Pobierz dane dostępowe']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_34(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'td',[[
        'style',
        'padding:0px !important'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_35)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.serverOS.name !== '');
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_ServerDashboardComponent_36(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '(',
      ')'
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.serverNetwork.length;
    ck(v,1,0,currVal_0);
  });
}
function View_ServerDashboardComponent_37(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',[[
        'class',
        'standard noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'td',[
      [
        'class',
        'text-center'
      ]
      ,
      [
        'colspan',
        '5'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/network.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak adresacji dodatkowej dla tego serwera'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_38(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'tr',([] as any[]),[[
        8,
        'className',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                        ',
      ' / ',
      '\n                                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showIPS(v.context.$implicit,import0.ɵnov((<any>(<any>v.parent).parent),51))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            Szczegóły\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',v.context.$implicit.type,'');
    ck(v,0,0,currVal_0);
    const currVal_1:any = v.context.$implicit.prefix;
    const currVal_2:any = v.context.$implicit.prefix_len;
    ck(v,3,0,currVal_1,currVal_2);
    const currVal_3:any = co.ipMethods.fromPrefixLen(v.context.$implicit.prefix_len);
    ck(v,6,0,currVal_3);
    const currVal_4:any = co.getServerGateway(v.context.$implicit['ips']);
    ck(v,9,0,currVal_4);
    const currVal_5:any = import0.ɵunv(v,12,0,import0.ɵnov(v,13).transform(('SUBNET.TYPE.' + v.context.$implicit.type.toUpperCase())));
    ck(v,12,0,currVal_5);
  });
}
function View_ServerDashboardComponent_40(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showRevDNSModal(import0.ɵnov((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent),2),v.context.$implicit.address,v.context.$implicit.rev_dns,(<any>v.parent).context.$implicit.id,v.context.$implicit.id,'additional',(<any>v.parent).context.$implicit.family)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '\n                                            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.address;
    ck(v,3,0,currVal_0);
  });
}
function View_ServerDashboardComponent_39(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),21,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_40)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Podsieć dodatkowa'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.getServersIP(v.context.$implicit['ips']);
    ck(v,5,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit.mask;
    ck(v,11,0,currVal_1);
    const currVal_2:any = v.context.$implicit.address;
    ck(v,14,0,currVal_2);
    const currVal_3:any = v.context.$implicit.family;
    ck(v,20,0,currVal_3);
  });
}
function View_ServerDashboardComponent_42(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showRevDNSModal(import0.ɵnov((<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent),2),v.context.$implicit.address,v.context.$implicit.rev_dns,(<any>v.parent).context.$implicit.id,v.context.$implicit.id,'failover',(<any>v.parent).context.$implicit.family)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      '\n                                            '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.address;
    ck(v,3,0,currVal_0);
  });
}
function View_ServerDashboardComponent_41(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),21,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_42)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['---'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Podsieć dodatkowa'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit['ips'];
    ck(v,5,0,currVal_0);
  },(ck,v) => {
    const currVal_1:any = v.context.$implicit.mask;
    ck(v,11,0,currVal_1);
    const currVal_2:any = v.context.$implicit.family;
    ck(v,20,0,currVal_2);
  });
}
function View_ServerDashboardComponent_26(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),106,'div',[[
        'class',
        'row-taller'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),103,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),101,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),99,'tr',[[
        'class',
        'noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),45,'td',[[
        'class',
        'text-top width-half'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zarządzanie'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),39,'table',[[
        'class',
        'standard noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'span',[[
        'class',
        'status-indicator'
      ]
      ],[[
        2,
        'active',
        (null as any)
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Stan:\n                                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),22,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_27)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_28)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_29)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_31)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_32)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_33)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_34)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),49,'td',[
      [
        'class',
        'text-top width-half'
      ]
      ,
      [
        'style',
        'padding-left: 10px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Adresacja IP '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_36)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),38,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),18,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Podsieć/IP'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Maska'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brama'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Typ'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_37)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),3,(null as any),View_ServerDashboardComponent_38)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpod([
      'itemsPerPage',
      'currentPage'
    ]
    ),
    import0.ɵpid(0,import8.PaginatePipe,[import8.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_39)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_41)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'pagination-controls',[
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.p = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_PaginationControlsComponent_0,import9.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import8.PaginationControlsComponent,([] as any[]),{
      directionLinks: [
        0,
        'directionLinks'
      ]
      ,
      previousLabel: [
        1,
        'previousLabel'
      ]
      ,
      nextLabel: [
        2,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:boolean = !co.serverIsReady;
    ck(v,31,0,currVal_2);
    const currVal_3:any = (co.serverIsReady && (co.serviceType == 'server'));
    ck(v,34,0,currVal_3);
    const currVal_4:any = (co.serverIsReady && (co.serviceType == 'server'));
    ck(v,37,0,currVal_4);
    const currVal_5:any = (co.serverIsReady && (co.serviceType == 'server'));
    ck(v,40,0,currVal_5);
    const currVal_6:any = (co.serverIsReady && (co.serviceType == 'server'));
    ck(v,43,0,currVal_6);
    const currVal_7:any = (co.serverIsReady && (co.serviceType == 'server'));
    ck(v,46,0,currVal_7);
    const currVal_8:any = (co.serverIsReady && (co.serviceType == 'server'));
    ck(v,49,0,currVal_8);
    const currVal_9:any = (co.serverNetwork && co.serverNetwork.length);
    ck(v,59,0,currVal_9);
    const currVal_10:boolean = !co.serverNetwork.length;
    ck(v,86,0,currVal_10);
    const currVal_11:any = import0.ɵunv(v,89,0,import0.ɵnov(v,91).transform(co.serverNetwork,ck(v,90,0,5,co.p)));
    ck(v,89,0,currVal_11);
    const currVal_12:any = co.serverNetwork['subnets_ipv6_additional'];
    ck(v,94,0,currVal_12);
    const currVal_13:any = co.serverNetwork['subnets_ipv6_failover'];
    ck(v,97,0,currVal_13);
    const currVal_14:any = 'true';
    const currVal_15:any = 'Poprzednie';
    const currVal_16:any = 'Następne';
    ck(v,102,0,currVal_14,currVal_15,currVal_16);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.serverStatus;
    ck(v,20,0,currVal_0);
    const currVal_1:any = (co.serverIsReady? (co.serverStatus? 'WŁĄCZONY': 'WYŁĄCZONY'): 'W PRZYGOTOWYWANIU');
    ck(v,23,0,currVal_1);
  });
}
function View_ServerDashboardComponent_44(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),13,'tr',[[
        'class',
        'ptr_records'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                                        ',
      '\n                                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',([] as any[]),(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.showPtr(v.context.$implicit,import0.ɵnov((<any>(<any>v.parent).parent),100))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                            Edytuj\n                                        '])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵted((null as any),['\n                                ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.name;
    ck(v,3,0,currVal_0);
    const currVal_1:any = v.context.$implicit.value;
    ck(v,6,0,currVal_1);
  });
}
function View_ServerDashboardComponent_43(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),54,'div',[[
        'class',
        'row-taller'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),51,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),49,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),47,'tr',[[
        'class',
        'noHover'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),44,'td',[[
        'class',
        'text-top'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'header',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                Rekordy PTR\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'options pull-right'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'wider search'
      ]
      ,
      [
        'type',
        'search'
      ]

    ]
    ,[
      [
        8,
        'value',
        0
      ]
      ,
      [
        8,
        'placeholder',
        0
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('keyup' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,17).inputChanged($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('input' === en)) {
        const pd_1:any = ((<any>(co.recordPtrValue = $event.target.value)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),25,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),12,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['IP'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Value'])),
    (l()(),import0.ɵted((null as any),['\n                                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),5,(null as any),View_ServerDashboardComponent_44)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpad(2),
    import0.ɵppd(3),
    import0.ɵpod([
      'itemsPerPage',
      'currentPage',
      'id'
    ]
    ),
    import0.ɵpid(0,import8.PaginatePipe,[import8.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'pagination-controls',[
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'id',
        'ptrPagination'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.ptrP = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_PaginationControlsComponent_0,import9.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import8.PaginationControlsComponent,([] as any[]),{
      id: [
        0,
        'id'
      ]
      ,
      directionLinks: [
        1,
        'directionLinks'
      ]
      ,
      previousLabel: [
        2,
        'previousLabel'
      ]
      ,
      nextLabel: [
        3,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = import0.ɵunv(v,41,0,import0.ɵnov(v,45).transform(import0.ɵunv(v,41,0,ck(v,43,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),0),co.ptrRecords,ck(v,42,0,'name','value'),co.recordPtrValue)),ck(v,44,0,10,co.ptrP,'ptrPagination')));
    ck(v,41,0,currVal_2);
    const currVal_3:any = 'ptrPagination';
    const currVal_4:any = 'true';
    const currVal_5:any = 'Poprzednie';
    const currVal_6:any = 'Następne';
    ck(v,50,0,currVal_3,currVal_4,currVal_5,currVal_6);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.recordPtrValue;
    const currVal_1:any = import0.ɵinlineInterpolate(1,'',import0.ɵunv(v,16,1,import0.ɵnov(v,18).transform('GENERAL.SEARCH')),'');
    ck(v,16,0,currVal_0,currVal_1);
  });
}
function View_ServerDashboardComponent_45(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'server-transfer',([] as any[]),(null as any),[[
        (null as any),
        'serviceIDChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('serviceIDChange' === en)) {
        const pd_0:any = ((<any>(co.serviceID = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_ServerTransferComponent_0,import10.RenderType_ServerTransferComponent)),
    import0.ɵdid(4243456,(null as any),0,import11.ServerTransferComponent,[
      import12.ApiService,
      import13.ResponseService
    ]
      ,{serviceID: [
        0,
        'serviceID'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.serviceID;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_ServerDashboardComponent_46(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Hasło'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,[[
        'password',
        1
      ]
    ],(null as any),0,'input',[
      [
        'readonly',
        ''
      ]
      ,
      [
        'style',
        'width: 100%;'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
      ,[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'input-button'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(212992,(null as any),0,import14.ClipboardDirective,[
      import0.ElementRef,
      import15.NotificationsService
    ]
      ,{elt: [
        0,
        'elt'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_1:any = import0.ɵnov(v,7);
    ck(v,10,0,currVal_1);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'',co.serverOSPassword,'');
    ck(v,7,0,currVal_0);
  });
}
function View_ServerDashboardComponent_47(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),8,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      ' ',
      ' '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                        ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.ip_address;
    ck(v,3,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform(('SUBNET.TYPE.' + v.context.$implicit.ip_type.toUpperCase())));
    ck(v,6,0,currVal_1);
  });
}
function View_ServerDashboardComponent_48(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'pagination-controls',[
      [
        'class',
        'nowrap'
      ]
      ,
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'id',
        'ips'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.p2 = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import9.View_PaginationControlsComponent_0,import9.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import8.PaginationControlsComponent,([] as any[]),{
      id: [
        0,
        'id'
      ]
      ,
      directionLinks: [
        1,
        'directionLinks'
      ]
      ,
      previousLabel: [
        2,
        'previousLabel'
      ]
      ,
      nextLabel: [
        3,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'ips';
    const currVal_1:any = 'true';
    const currVal_2:any = 'Poprzednie';
    const currVal_3:any = 'Następne';
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
function View_ServerDashboardComponent_49(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'errors'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('ERRORS.REQUIRED'));
    ck(v,1,0,currVal_0);
  });
}
function View_ServerDashboardComponent_51(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'errors'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('DOMAINS.RECORDS.ERRORS.DOMAIN_NAME'));
    ck(v,1,0,currVal_0);
  });
}
function View_ServerDashboardComponent_52(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'errors'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('DOMAINS.RECORDS.ERRORS.RECORD_VALUE'));
    ck(v,1,0,currVal_0);
  });
}
function View_ServerDashboardComponent_50(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_51)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_52)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ((co.ptrForm.controls['value'].errors == null)? (null as any): co.ptrForm.controls['value'].errors.domain_name);
    ck(v,3,0,currVal_0);
    const currVal_1:any = (((co.ptrForm.controls['value'].errors == null)? (null as any): co.ptrForm.controls['value'].errors.record_value) && !((co.ptrForm.controls['value'].errors == null)? (null as any): co.ptrForm.controls['value'].errors.domain_name));
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_ServerDashboardComponent_24(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),142,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_25)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_26)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_43)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_45)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),34,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import16.View_Modal_0,import16.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'osDataModal',
        4
      ]
      ],0,import17.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalHeader_0,import16.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import17.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dane dostępowe'])),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),1,19,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalContent_0,import16.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import17.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,12,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Login '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,[[
        'login',
        1
      ]
    ],(null as any),0,'input',[
      [
        'readonly',
        ''
      ]
      ,
      [
        'style',
        'width: 100%;'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
      ,[[
        8,
        'value',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'input-button'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(212992,(null as any),0,import14.ClipboardDirective,[
      import0.ElementRef,
      import15.NotificationsService
    ]
      ,{elt: [
        0,
        'elt'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_ServerDashboardComponent_46)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),2,2,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalFooter_0,import16.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import17.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),47,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import16.View_Modal_0,import16.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'IPSModalData',
        4
      ]
      ],0,import17.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),0,9,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalHeader_0,import16.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import17.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    Adresy podsieci ',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    Maska podsieci: ',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    Brama podsieci: ',
      '\n                '
    ]
    )),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),1,28,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalContent_0,import16.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import17.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,21,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Adres IP'])),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Type'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),3,(null as any),View_ServerDashboardComponent_47)),
    import0.ɵdid(802816,(null as any),0,import1.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpod([
      'id',
      'itemsPerPage',
      'currentPage',
      'totalItems'
    ]
    ),
    import0.ɵpid(0,import8.PaginatePipe,[import8.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_ServerDashboardComponent_48)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),2,2,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalFooter_0,import16.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import17.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),42,'modal',[
      [
        'class',
        'small noHover noScroll'
      ]
      ,
      [
        'submitButtonLabel',
        'Aktualizuj'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.updatePtr(co.ptrRecord,import0.ɵnov(v,100))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import16.View_Modal_0,import16.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'PTRModalData',
        4
      ]
    ],0,import17.Modal,([] as any[]),{
      closeOnEscape: [
        0,
        'closeOnEscape'
      ]
      ,
      closeOnOutsideClick: [
        1,
        'closeOnOutsideClick'
      ]
      ,
      submitButtonLabel: [
        2,
        'submitButtonLabel'
      ]

    }
    ,{onSubmit: 'onSubmit'}),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),0,7,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalHeader_0,import16.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import17.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),0,3,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    IP: ',
      ''
    ]
    )),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),1,29,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalContent_0,import16.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import17.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),0,25,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,116).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,116).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Value:'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'input-area static'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'medium-wide'
      ]
      ,
      [
        'formControlName',
        'value'
      ]
      ,
      [
        'placeholder',
        'Podaj wartość rekordu'
      ]
      ,
      [
        'style',
        'width:100%'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        8,
        'value',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,126)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,126).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,126)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,126)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,131).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_49)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_50)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.mainServerNetwork;
    ck(v,3,0,currVal_0);
    const currVal_1:boolean = !co.server.is_colocated;
    ck(v,6,0,currVal_1);
    const currVal_2:any = ((co.ptrRecords && (co.ptrRecords.length > 0)) && !co.server.is_colocated);
    ck(v,9,0,currVal_2);
    const currVal_3:any = (co.server.transfer_visible && !co.server.is_colocated);
    ck(v,12,0,currVal_3);
    const currVal_4:any = 'Zamknij';
    ck(v,15,0,currVal_4);
    const currVal_6:any = import0.ɵnov(v,34);
    ck(v,37,0,currVal_6);
    const currVal_7:any = co.serverOSPassword;
    ck(v,42,0,currVal_7);
    const currVal_8:any = 'Zamknij';
    ck(v,51,0,currVal_8);
    const currVal_12:any = import0.ɵunv(v,84,0,import0.ɵnov(v,86).transform(co.getModalElements(),ck(v,85,0,'ips',5,co.p2,co.getModalElements().length)));
    ck(v,84,0,currVal_12);
    const currVal_13:any = (co.getModalElements().length > 5);
    ck(v,91,0,currVal_13);
    const currVal_14:any = true;
    const currVal_15:any = false;
    const currVal_16:any = 'Aktualizuj';
    ck(v,100,0,currVal_14,currVal_15,currVal_16);
    const currVal_25:any = co.ptrForm;
    ck(v,116,0,currVal_25);
    const currVal_34:any = 'value';
    ck(v,128,0,currVal_34);
    const currVal_35:any = (co.ptrForm.controls['value'] && ((co.ptrForm.controls['value'].errors == null)? (null as any): co.ptrForm.controls['value'].errors.required));
    ck(v,135,0,currVal_35);
    const currVal_36:any = (co.ptrForm.controls['value'].value && co.ptrForm.controls['value'].value.length);
    ck(v,138,0,currVal_36);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_5:any = import0.ɵinlineInterpolate(1,'',co.serverOSLogin,'');
    ck(v,34,0,currVal_5);
    const currVal_9:any = co.modalElements.prefix;
    ck(v,57,0,currVal_9);
    const currVal_10:any = co.ipMethods.fromPrefixLen(co.modalElements.prefix_len);
    ck(v,59,0,currVal_10);
    const currVal_11:any = co.getServerGateway(co.modalElements.ips);
    ck(v,61,0,currVal_11);
    const currVal_17:any = (co.ptrRecord? co.ptrRecord.name: 'Proszę wybrać rekord');
    ck(v,106,0,currVal_17);
    const currVal_18:any = import0.ɵnov(v,118).ngClassUntouched;
    const currVal_19:any = import0.ɵnov(v,118).ngClassTouched;
    const currVal_20:any = import0.ɵnov(v,118).ngClassPristine;
    const currVal_21:any = import0.ɵnov(v,118).ngClassDirty;
    const currVal_22:any = import0.ɵnov(v,118).ngClassValid;
    const currVal_23:any = import0.ɵnov(v,118).ngClassInvalid;
    const currVal_24:any = import0.ɵnov(v,118).ngClassPending;
    ck(v,114,0,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24);
    const currVal_26:any = import0.ɵinlineInterpolate(1,'',(co.ptrRecord? co.ptrRecord.value: ''),'');
    const currVal_27:any = import0.ɵnov(v,130).ngClassUntouched;
    const currVal_28:any = import0.ɵnov(v,130).ngClassTouched;
    const currVal_29:any = import0.ɵnov(v,130).ngClassPristine;
    const currVal_30:any = import0.ɵnov(v,130).ngClassDirty;
    const currVal_31:any = import0.ɵnov(v,130).ngClassValid;
    const currVal_32:any = import0.ɵnov(v,130).ngClassInvalid;
    const currVal_33:any = import0.ɵnov(v,130).ngClassPending;
    ck(v,125,0,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33);
  });
}
function View_ServerDashboardComponent_53(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'empty-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'src',
        '../../assets/images/icons/gears.png'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Twój serwer jest w trakcie konfigurowania'])),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_ServerDashboardComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),34,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_16)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_20)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n          '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_21)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'options blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_22)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_23)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_24)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_53)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.showChangeServerName;
    ck(v,5,0,currVal_0);
    const currVal_1:boolean = !co.showChangeServerName;
    ck(v,10,0,currVal_1);
    const currVal_2:boolean = !co.showChangeServerName;
    ck(v,16,0,currVal_2);
    const currVal_3:any = co.serverIsReady;
    ck(v,22,0,currVal_3);
    const currVal_4:any = co.server.status_online;
    ck(v,27,0,currVal_4);
    const currVal_5:any = co.serverIsReady;
    ck(v,30,0,currVal_5);
    const currVal_6:boolean = !co.serverIsReady;
    ck(v,33,0,currVal_6);
  },(null as any));
}
export function View_ServerDashboardComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import18.FilterByKeysPipe,([] as any[])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),52,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import16.View_Modal_0,import16.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'revdnsModal',
        4
      ]
      ],0,import17.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalHeader_0,import16.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import17.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zmiana revDNS'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,34,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalContent_0,import16.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import17.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,30,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,16).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,16).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),6,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['IP: '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'strong',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['revDNS'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[[
        'class',
        'input-area static'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'medium-wide'
      ]
      ,
      [
        'formControlName',
        'rev_dns'
      ]
      ,
      [
        'style',
        'width: 100%;'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,36)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,36).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,36)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,36)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,41).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,5,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalFooter_0,import16.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import17.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import19.ServerDashboardComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.changeRevDNS(import0.ɵnov(v,2))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Zmień'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),23,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import16.View_Modal_0,import16.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'powerModal',
        4
      ]
      ],0,import17.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalHeader_0,import16.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import17.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,5,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalContent_0,import16.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import17.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      'Czy na pewno chcesz ',
      ' serwer?'
    ]
    )),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,5,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalFooter_0,import16.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import17.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,1,'button',[[
        'class',
        'btn btn-short-plus'
      ]
      ],[[
        8,
        'disabled',
        0
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import19.ServerDashboardComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.onOffServer((co.serverStatus? 'off': 'on'),import0.ɵnov(v,56))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),23,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import16.View_Modal_0,import16.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'restartModal',
        4
      ]
      ],0,import17.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,5,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalHeader_0,import16.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import17.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'h5',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Uwaga!'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,5,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalContent_0,import16.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import17.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),0,1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Czy na pewno chcesz zrestartować serwer?'])),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,5,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalFooter_0,import16.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import17.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_ServerDashboardComponent_1)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),84,'modal',[
      [
        'cancelButtonLabel',
        'Zamknij'
      ]
      ,
      [
        'class',
        'small'
      ]

    ]
    ,(null as any),(null as any),(null as any),import16.View_Modal_0,import16.RenderType_Modal)),
      import0.ɵdid(180224,[[
        'ipmiManager',
        4
      ]
      ],0,import17.Modal,([] as any[]),{cancelButtonLabel: [
        0,
        'cancelButtonLabel'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),0,2,'modal-header',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalHeader_0,import16.RenderType_ModalHeader)),
    import0.ɵdid(49152,(null as any),0,import17.ModalHeader,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        Dostęp do karty zarządzającej\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),1,72,'modal-content',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalContent_0,import16.RenderType_ModalContent)),
    import0.ɵdid(49152,(null as any),0,import17.ModalContent,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,47,'form',[[
        'novalidate',
        ''
      ]
    ],[
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'submit'
      ]
      ,
      [
        (null as any),
        'reset'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      var co:import19.ServerDashboardComponent = v.component;
      if (('submit' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,117).onSubmit($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('reset' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,117).onReset()) !== false);
        ad = (pd_1 && ad);
      }
      if (('submit' === en)) {
        const pd_2:any = ((<any>co.getIPMIAccess()) !== false);
        ad = (pd_2 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.ɵbf,([] as any[]),(null as any),(null as any)),
    import0.ɵdid(540672,(null as any),0,import6.FormGroupDirective,[
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]

    ]
      ,{form: [
        0,
        'form'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.ControlContainer,(null as any),[import6.FormGroupDirective]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatusGroup,[import6.ControlContainer],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),40,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),37,'div',[[
        'class',
        'row-standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'label',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Adres IP: '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[
      [
        'class',
        'input-box'
      ]
      ,
      [
        'style',
        'margin-bottom:10px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'input-area'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'input',[
      [
        'appNoBlank',
        ''
      ]
      ,
      [
        'class',
        'long'
      ]
      ,
      [
        'formControlName',
        'allowed_ip'
      ]
      ,
      [
        'type',
        'text'
      ]

    ]
    ,[
      [
        1,
        'disabled',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
    ,[
      [
        (null as any),
        'input'
      ]
      ,
      [
        (null as any),
        'blur'
      ]
      ,
      [
        (null as any),
        'compositionstart'
      ]
      ,
      [
        (null as any),
        'compositionend'
      ]
      ,
      [
        (null as any),
        'keyup'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('input' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,136)._handleInput($event.target.value)) !== false);
        ad = (pd_0 && ad);
      }
      if (('blur' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,136).onTouched()) !== false);
        ad = (pd_1 && ad);
      }
      if (('compositionstart' === en)) {
        const pd_2:any = ((<any>import0.ɵnov(v,136)._compositionStart()) !== false);
        ad = (pd_2 && ad);
      }
      if (('compositionend' === en)) {
        const pd_3:any = ((<any>import0.ɵnov(v,136)._compositionEnd($event.target.value)) !== false);
        ad = (pd_3 && ad);
      }
      if (('keyup' === en)) {
        const pd_4:any = ((<any>import0.ɵnov(v,141).inputChanged($event)) !== false);
        ad = (pd_4 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import6.DefaultValueAccessor,[
      import0.Renderer,
      import0.ElementRef,
      [
        2,
        import6.COMPOSITION_BUFFER_MODE
      ]

    ]
    ,(null as any),(null as any)),
    import0.ɵprd(1024,(null as any),import6.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import6.DefaultValueAccessor]),
    import0.ɵdid(671744,(null as any),0,import6.FormControlName,[
      [
        3,
        import6.ControlContainer
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import6.NG_VALUE_ACCESSOR
      ]

    ]
      ,{name: [
        0,
        'name'
      ]
    },(null as any)),
    import0.ɵprd(2048,(null as any),import6.NgControl,(null as any),[import6.FormControlName]),
    import0.ɵdid(16384,(null as any),0,import6.NgControlStatus,[import6.NgControl],(null as any),(null as any)),
    import0.ɵdid(16384,(null as any),0,import7.NoBlankDirective,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_2)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_5)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_6)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_7)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_8)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted(0,['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),0,16,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_9)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_10)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_11)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_12)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),0,1,(null as any),View_ServerDashboardComponent_13)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(0,['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),2,2,'modal-footer',([] as any[]),(null as any),(null as any),(null as any),import16.View_ModalFooter_0,import16.RenderType_ModalFooter)),
    import0.ɵdid(49152,(null as any),0,import17.ModalFooter,([] as any[]),(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n\n\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_14)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n\n'])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServerDashboardComponent_15)),
    import0.ɵdid(16384,(null as any),0,import1.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import19.ServerDashboardComponent = v.component;
    const currVal_0:any = 'Zamknij';
    ck(v,2,0,currVal_0);
    const currVal_8:any = co.revDNSForm;
    ck(v,16,0,currVal_8);
    const currVal_17:any = 'rev_dns';
    ck(v,38,0,currVal_17);
    const currVal_18:any = 'Zamknij';
    ck(v,56,0,currVal_18);
    const currVal_22:any = 'Zamknij';
    ck(v,81,0,currVal_22);
    const currVal_23:any = co.serverStatus;
    ck(v,101,0,currVal_23);
    const currVal_24:any = 'Zamknij';
    ck(v,106,0,currVal_24);
    const currVal_32:any = co.IPMIAccessForm;
    ck(v,117,0,currVal_32);
    const currVal_41:any = 'allowed_ip';
    ck(v,138,0,currVal_41);
    const currVal_42:any = (co.IPMIAccessForm.controls['allowed_ip'].touched && co.IPMIAccessForm.controls['allowed_ip'].errors);
    ck(v,144,0,currVal_42);
    const currVal_43:boolean = !co.IPMIData.nat_fqdn;
    ck(v,150,0,currVal_43);
    const currVal_44:any = co.IPMIData.nat_fqdn;
    ck(v,153,0,currVal_44);
    const currVal_45:boolean = (!co.IPMIData.nat_fqdn && co.allowedMyIP);
    ck(v,156,0,currVal_45);
    const currVal_46:boolean = (!co.IPMIData.nat_fqdn && !co.allowedMyIP);
    ck(v,159,0,currVal_46);
    const currVal_47:any = co.IPMIData.nat_ip;
    ck(v,169,0,currVal_47);
    const currVal_48:any = co.IPMIData.nat_fqdn;
    ck(v,172,0,currVal_48);
    const currVal_49:any = (co.IPMIData.nat_fqdn && co.IPMIData.operator_name);
    ck(v,175,0,currVal_49);
    const currVal_50:any = (co.IPMIData.nat_fqdn && co.IPMIData.operator_pass);
    ck(v,178,0,currVal_50);
    const currVal_51:any = (((co.IPMIData.operator_pass && co.IPMIData.operator_name) && co.IPMIData.nat_fqdn) && co.IPMIData.autologin);
    ck(v,183,0,currVal_51);
    const currVal_52:any = co.loadingServerData;
    ck(v,192,0,currVal_52);
    const currVal_53:boolean = !co.loadingServerData;
    ck(v,195,0,currVal_53);
  },(ck,v) => {
    var co:import19.ServerDashboardComponent = v.component;
    const currVal_1:any = import0.ɵnov(v,18).ngClassUntouched;
    const currVal_2:any = import0.ɵnov(v,18).ngClassTouched;
    const currVal_3:any = import0.ɵnov(v,18).ngClassPristine;
    const currVal_4:any = import0.ɵnov(v,18).ngClassDirty;
    const currVal_5:any = import0.ɵnov(v,18).ngClassValid;
    const currVal_6:any = import0.ɵnov(v,18).ngClassInvalid;
    const currVal_7:any = import0.ɵnov(v,18).ngClassPending;
    ck(v,14,0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_9:any = co.revDNSForm.controls['ip'].value;
    ck(v,25,0,currVal_9);
    const currVal_10:any = import0.ɵnov(v,40).ngClassUntouched;
    const currVal_11:any = import0.ɵnov(v,40).ngClassTouched;
    const currVal_12:any = import0.ɵnov(v,40).ngClassPristine;
    const currVal_13:any = import0.ɵnov(v,40).ngClassDirty;
    const currVal_14:any = import0.ɵnov(v,40).ngClassValid;
    const currVal_15:any = import0.ɵnov(v,40).ngClassInvalid;
    const currVal_16:any = import0.ɵnov(v,40).ngClassPending;
    ck(v,35,0,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16);
    const currVal_19:any = (co.serverStatus? 'wyłączyć': 'włączyć');
    ck(v,69,0,currVal_19);
    const currVal_20:any = co.checkingStatus;
    ck(v,75,0,currVal_20);
    const currVal_21:any = ((co.serverStatus == (null as any))? 'Czekaj...': (co.serverStatus? 'Wyłącz': 'Włącz'));
    ck(v,76,0,currVal_21);
    const currVal_25:any = import0.ɵnov(v,119).ngClassUntouched;
    const currVal_26:any = import0.ɵnov(v,119).ngClassTouched;
    const currVal_27:any = import0.ɵnov(v,119).ngClassPristine;
    const currVal_28:any = import0.ɵnov(v,119).ngClassDirty;
    const currVal_29:any = import0.ɵnov(v,119).ngClassValid;
    const currVal_30:any = import0.ɵnov(v,119).ngClassInvalid;
    const currVal_31:any = import0.ɵnov(v,119).ngClassPending;
    ck(v,115,0,currVal_25,currVal_26,currVal_27,currVal_28,currVal_29,currVal_30,currVal_31);
    const currVal_33:any = co.IPMIData.nat_fqdn;
    const currVal_34:any = import0.ɵnov(v,140).ngClassUntouched;
    const currVal_35:any = import0.ɵnov(v,140).ngClassTouched;
    const currVal_36:any = import0.ɵnov(v,140).ngClassPristine;
    const currVal_37:any = import0.ɵnov(v,140).ngClassDirty;
    const currVal_38:any = import0.ɵnov(v,140).ngClassValid;
    const currVal_39:any = import0.ɵnov(v,140).ngClassInvalid;
    const currVal_40:any = import0.ɵnov(v,140).ngClassPending;
    ck(v,135,0,currVal_33,currVal_34,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39,currVal_40);
  });
}
function View_ServerDashboardComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-server-dashboard',([] as any[]),(null as any),(null as any),(null as any),View_ServerDashboardComponent_0,RenderType_ServerDashboardComponent)),
    import0.ɵdid(114688,(null as any),0,import19.ServerDashboardComponent,[
      import12.ApiService,
      import20.LocalStorageService,
      import15.NotificationsService,
      import21.IpmiService,
      import13.ResponseService,
      import22.ActivatedRoute,
      import22.Router,
      import23.FormService,
      import24.MenuService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ServerDashboardComponentNgFactory:import0.ComponentFactory<import19.ServerDashboardComponent> = import0.ɵccf('app-server-dashboard',import19.ServerDashboardComponent,View_ServerDashboardComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/server/server-dashboard.component.ngfactory.ts